import { render, staticRenderFns } from "./createArticleTagDialog.vue?vue&type=template&id=22fc2faa&scoped=true&"
import script from "./createArticleTagDialog.vue?vue&type=script&lang=js&"
export * from "./createArticleTagDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fc2faa",
  null
  
)

export default component.exports